<template>
  <div class="text-input-container">
    <template v-if="textInputStyle === 3">
      <input
        :type="inputType"
        class="ntable--textfield"
        :name="id"
        :id="id"
        :placeholder="placeholder"
        :value="textInputValue"
        @blur="onTextInputBlur"
        @focus="onTextInputFocus"
        @keyup="onTextInputKeyup"
        :disabled="disabled"
      />
    </template>
    <v-menu
      v-if="isPickerType"
      :close-on-content-click="false"
      :close-on-click="false"
      :value="pickerMenu"
      :nudge-right="50"
      transition="slide-y-transition"
      full-width
      offset-y
    >
      <div slot="activator" @click.stop class="text-input-dropdown-activator"></div>
      <v-time-picker v-if="isTimeType" v-model="textInputValue" full-width @change="onTimeChange"></v-time-picker>
      <v-date-picker v-if="isDateType" :value="textInputValue" @input="onDateChange"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import { TextFieldMixin } from "./text-field.mixin";

export default {
  props: {
    textInputStyle: {
      type: Number,
      default: 1
    }
  },
  mixins: [TextFieldMixin()]
};
</script>


<style lang="scss">
  .text-input-container {
    height: 100%;
    width: 100%;

    .ntable--textfield {
      width: 100%;
    }
  }
</style>